/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var tooltip = null;
  var activePill = null;

  function show(pill) {
    var text = pill.getAttribute('data-info');
    if (!text || pill === activePill) return;

    hide();
    activePill = pill;

    tooltip = document.createElement('div');
    tooltip.className = 'metafield-tooltip';
    tooltip.textContent = text;
    document.body.appendChild(tooltip);

    var rect = pill.getBoundingClientRect();
    tooltip.style.left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2 + 'px';
    tooltip.style.top = rect.top - tooltip.offsetHeight - 8 + window.scrollY + 'px';
    tooltip.style.position = 'absolute';

    requestAnimationFrame(function () {
      if (tooltip) tooltip.classList.add('is-visible');
    });
  }

  function hide() {
    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
    activePill = null;
  }

  document.addEventListener('mouseover', function (e) {
    var pill = e.target.closest && e.target.closest('[data-info]');
    if (pill) {
      show(pill);
    } else if (activePill) {
      hide();
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!activePill) return;
    var related = e.relatedTarget;
    if (!related || !activePill.contains(related)) {
      hide();
    }
  });
})();

/* ==========================================================================
   Add to cart: loading spinner + AJAX in-cart indicator update
   ========================================================================== */

(function () {
  /* 0. Read translated "in cart" label from Liquid-injected JSON */
  var inCartTemplate = 'In cart: __COUNT__ pcs';
  try {
    var el = document.getElementById('cart-translations');
    if (el) inCartTemplate = JSON.parse(el.textContent).in_cart_html;
  } catch (e) {}

  /* 1. Add loading spinner to button on click (capture phase — buy-button stops propagation) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-item__action-button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.classList.add('is-loading');
  }, true);

  /* 2. Shared function: refresh all in-cart indicators */
  function refreshInCartIndicators() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartMap = {};
        cart.items.forEach(function (item) {
          var pid = item.product_id;
          cartMap[pid] = (cartMap[pid] || 0) + item.quantity;
        });

        document.querySelectorAll('.product-item__action-list').forEach(function (form) {
          var pidInput = form.querySelector('input[name="product-id"]');
          if (!pidInput) return;
          var pid = parseInt(pidInput.value, 10);
          var qty = cartMap[pid] || 0;
          var existing = form.querySelector('.product-item__in-cart');

          if (qty > 0) {
            var label = inCartTemplate.replace('__COUNT__', qty);
            var html = '<div class="product-item__in-cart">' +
              '<svg focusable="false" class="icon icon--check" viewBox="0 0 24 24" role="presentation">' +
              '<path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path></svg>' +
              label + '</div>';
            if (existing) {
              existing.outerHTML = html;
            } else {
              var buyBtn = form.querySelector('buy-button');
              if (buyBtn) buyBtn.insertAdjacentHTML('beforebegin', html);
            }
          } else if (existing) {
            existing.remove();
          }
        });
      });
  }

  /* 3. Update after product added */
  document.addEventListener('product:added', function () {
    document.querySelectorAll('.product-item__action-button.is-loading').forEach(function (btn) {
      btn.classList.remove('is-loading');
    });
    refreshInCartIndicators();
  });

  /* 4. Update after cart changes (item removed, quantity changed) */
  document.addEventListener('cart:refresh', function () {
    refreshInCartIndicators();
  });

  /* 5. Also catch cart count mutations (covers mini-cart removals) */
  var cartCountEl = document.querySelector('.header__cart-count');
  if (cartCountEl) {
    new MutationObserver(function () {
      refreshInCartIndicators();
    }).observe(cartCountEl, { childList: true, characterData: true, subtree: true });
  }
})();

/* ==========================================================================
   Deposit (pantti) – worker-based variant lookup + auto-add + quantity sync
   ========================================================================== */
(() => {
  const WORKER_URL = 'https://bpf-deposit-worker.hagrowly.workers.dev';

  /** deposit_code → variant_id, in-memory cache for the current page load */
  const variantCache = new Map();

  async function lookupDepositVariantId(depositCode) {
    if (variantCache.has(depositCode)) return variantCache.get(depositCode);

    try {
      const response = await fetch(`${WORKER_URL}/lookup?code=${encodeURIComponent(depositCode)}`);
      const { variant_id } = await response.json();
      if (variant_id) variantCache.set(depositCode, variant_id);
      return variant_id ?? null;
    } catch (err) {
      console.error(`[deposit] Worker lookup failed for code "${depositCode}":`, err);
      return null;
    }
  }

  async function addDepositToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity, properties: { _deposit: '1' } }),
    });
    if (!response.ok) {
      const error = await response.json();
      console.error(`[deposit] Failed to add deposit variant ${variantId}:`, error);
      return false;
    }
    return true;
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* --- Auto-add when a product is added to cart --- */
  document.addEventListener('product:added', async (event) => {
    if (!event.detail?.productAdded) return;

    const { button, quantity = 1 } = event.detail;
    if (!button) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    const depositEl = form.querySelector('[data-deposit-code]') ?? button.closest('[data-deposit-code]');
    const depositCode = depositEl?.getAttribute('data-deposit-code');
    if (!depositCode) return;

    const variantId = await lookupDepositVariantId(depositCode);
    if (!variantId) return;

    const ok = await addDepositToCart(variantId, quantity);
    if (ok) refreshCart();
  });

  /* --- Sync deposit quantities after any cart change --- */
  let isSyncing = false;

  async function syncDepositQuantities() {
    if (isSyncing) return;

    // Skip sync in the Shopify theme editor — cart state is mock/preview data,
    // not a real customer cart, so quantity checks would be meaningless.
    if (Shopify?.designMode) return;

    // Build expected quantities from main products currently visible in DOM
    const expectedByCode = new Map();
    document.querySelectorAll('[data-deposit-code][data-line-qty]').forEach((el) => {
      const code = el.getAttribute('data-deposit-code');
      const qty = parseInt(el.getAttribute('data-line-qty'), 10) || 0;
      expectedByCode.set(code, (expectedByCode.get(code) ?? 0) + qty);
    });

    // Resolve deposit codes → variant IDs and build expected quantity map
    const expectedByVariant = new Map();
    await Promise.all(
      [...expectedByCode.entries()].map(async ([code, qty]) => {
        const variantId = await lookupDepositVariantId(code);
        if (!variantId) return;
        const key = String(variantId);
        expectedByVariant.set(key, (expectedByVariant.get(key) ?? 0) + qty);
      })
    );

    // Safety guard: main products with deposit codes are in DOM but the worker
    // couldn't resolve any of them. Abort — don't zero deposits on a lookup failure.
    if (expectedByCode.size > 0 && expectedByVariant.size === 0) {
      console.warn('[deposit] Worker returned no variant IDs — skipping deposit sync');
      return;
    }

    // Fetch current cart
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());

    // Identify deposit items by their _deposit line property or by matching a known deposit variant
    const depositItems = cart.items.filter((item) => {
      const key = String(item.variant_id);
      return item.properties?._deposit === '1' || expectedByVariant.has(key);
    });

    if (!depositItems.length) return;

    const updates = {};
    depositItems.forEach((item) => {
      const key = String(item.variant_id);
      // If main products ARE visible in DOM but this specific deposit's variant
      // wasn't resolved by the worker, skip it — the worker failed for this code.
      // (When expectedByCode is empty, all deposits are orphans → let expected = 0 remove them.)
      if (expectedByCode.size > 0 && !expectedByVariant.has(key)) return;
      const expected = expectedByVariant.get(key) ?? 0;
      if (item.quantity !== expected) updates[key] = expected;
    });

    if (!Object.keys(updates).length) return;

    isSyncing = true;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      // On the cart page a reload is cleaner than a mini-cart refresh
      if (window.theme?.pageType === 'cart') {
        window.location.reload();
      } else {
        refreshCart();
      }
    } catch (err) {
      console.error('[deposit] Quantity sync failed:', err);
    } finally {
      isSyncing = false;
    }
  }

  // cart:rerendered is dispatched on .header__action-item--cart WITHOUT bubbling for the
  // mini-cart path (theme.js line 6661 — Cart class, this.element is the cart action item).
  // document.addEventListener and the <section> parent never receive it.
  // We must attach directly to that specific element.
  function attachCartListener() {
    const cartActionItem = document.querySelector('.header__action-item--cart');
    cartActionItem?.addEventListener('cart:rerendered', syncDepositQuantities);

    // Run sync on every page load. The mini-cart section is always present in the
    // DOM (hidden drawer), so data-deposit-code elements are available regardless
    // of which page we're on. This catches orphaned deposits left from any previous
    // session where a main product was removed but the deposit wasn't cleaned up.
    syncDepositQuantities();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachCartListener);
  } else {
    attachCartListener();
  }

  // Catch the bubbling version too (cart page rerenders via AJAX without full reload)
  document.addEventListener('cart:rerendered', syncDepositQuantities);
})();
